import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * OptionsHeader: Design section Component; It acts as the main
 * header of the option listing component.
 */

export function OptionsHeader({ optionsTitle, children }) {
  return (
    <div className={style.optionsHeader}>
      <h5>{optionsTitle}</h5>
      {children}
    </div>
  );
}

OptionsHeader.propTypes = {
  /**
   * Title to be displayed for OptionsListing
   */
  optionsTitle: PropTypes.string,
  /**
   * Child element to be displayed inside the header component
   * Usually the ErrorControlBlock Element that display the
   * number of error steps committed aganist total allowed errors
   */
  children: PropTypes.element,
};
